import LocalState from '../state/LocalState';

const timeSinceStart = (state: LocalState, time?: number): number => {
  //const x = time;
  time = typeof time === 'number' ? time : Date.now();
  //const start = state.play.start;
  //console.error('timeSinceStart:', { start, play: state.play, time, x });
  return time - state.play.start;
};
export default timeSinceStart;
